/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchend", "mouseenter", "mouseleave", "focusout"];

    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === 'click' || type === 'touchend') {
        this.toggleCTA.addEventListener(type, (evt) => {
          evt.preventDefault();
          this.toggleDropdown();
        });
      } else if(type === 'mouseenter') {
        this.toggleCTA.addEventListener(type, (evt) => {
          this.dropdownShow(this.dropdown);
          this.childOnFocusChange(this.dropdown);
        });
      } else if(type === 'mouseleave') {
        this.dropdown.addEventListener(type, (evt) => {
          this.dropdownHide(this.dropdown);
        });
      } else if(type == 'focusout'){
        this.dropdown.addEventListener(type, (evt) => {
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown);
          }
        });
      }
    });
  
    document.addEventListener('click', (event) => {
      if (!this.dropdown.contains(event.target) && this.dropdown.classList.contains('open')) {
        this.dropdownHide(this.dropdown);
      }
    });
  
    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.close-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {return;}

    // Close sibling dropdowns
    const siblings = Array.from(dropdownParent.parentElement.children).filter((el) => el !== dropdownParent && el.classList.contains('megamenu') && el.classList.contains('open'));
    siblings?.forEach((sibling) => {
      sibling.classList.remove('open');
      const toggle = sibling.querySelector('.dropdown-toggle');
      if(toggle) toggle.setAttribute('aria-expanded', false);
    });

    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
  
    let predictiveSearchEles = document.querySelectorAll('predictive-search .predictive-search');
    predictiveSearchEles?.forEach(predictiveSearchEle => {
      let predictiveSearch = predictiveSearchEle?.classList.contains("show-results");
      if(predictiveSearch) predictiveSearchEle?.classList.remove("show-results");
      if (predictiveSearch && predictiveSearchEle) {predictiveSearchEle.innerHTML = '';}
    });

    document.querySelectorAll('#Search-In-Modal').forEach(ele => { 
      ele.value='';
    })
     
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', false);
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  hideOverlay(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
    document.body.classList.remove('search-open');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container?.querySelector('[data-trigger-video]');

  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.autoplay == 'true' && !this.closest('swiper-slide') && this.placementType !== 'popup') this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
        this.videoSection.setAttribute('aria-hidden', 'false');
        this._playVideo(videoElement);
        if (this.dataset.controls == 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type === 'youtube') {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '').replace('https://youtu.be/', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=${this.dataset.autoplay == 'true' ? 1 : 0}&muted=${this.dataset.muted == 'true' ? 1 : 0}&controls=${this.dataset.controls == 'true' ? 1 : 0}&loop=${this.dataset.loop == 'true' ? 1 : 0}&enablejsapi=1&origin=${window.origin}` );
      // &playlist=${videoID}
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    this.scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        this.scrollObserver.disconnect();
        return;
      }

      if(!entries[0].isIntersecting){
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  autoplayOnInit(element = this){
    const elementIntersection = (entries) => {
      if(entries[0].isIntersecting && entries[0].intersectionRatio > 0){
        element.toggleView();
        observeElement.disconnect();
      }
    };
    let observeElement = new IntersectionObserver(elementIntersection);
    observeElement.observe(element);
  }
}
customElements.define("custom-video", CustomVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalDialog = this.querySelector('.modal-dialog');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    // this.addEventListener('click', (evt) => {
    //   if (evt.target === this) this.hide();
    // });

    this.addEventListener('click', (evt) => {
      if (!this.modalDialog.contains(evt.target)) {
        this.hide();
      }
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') this.querySelector('.video-container').innerHTML = '';
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
      this.closeButtons = this.querySelectorAll('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons?.forEach(btn => {
      btn.removeEventListener('click', this.closeDrawer.bind(this));
    });
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if(btn.dataset.for == 'collection-sorting'){
          this.classList.add('collection-sorting');
          setTimeout(() => {
            (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.target);
          }, 500);
        }else{
          (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
        }
        
      });
    });

    // this.closeButton?.addEventListener('click', this.closeDrawer.bind(this));
    this.closeButtons?.forEach(btn => {
      btn.addEventListener('click', this.closeDrawer.bind(this));
    });
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));

     // Close when clicking outside
    document.addEventListener('mouseup', (e) => {
      if (this.isOpen && !this.contains(e.target) && !e.target.closest('[data-toggle-drawer]')) {
        this.closeDrawer(e);
      }
    });
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(evt) {
    if(evt.code && evt.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.openedBy?.setAttribute('aria-expanded', true);

    if (!opener.closest('[data-result-wrapper-ele]')) {SiteOverlay.prototype.showOverlay()}
    else if((opener.dataset.toggledrawer == 'storefront-filter-drawer' || opener.dataset.for == 'collection-sorting') && opener.closest('[data-result-wrapper-ele]')) {document.body.classList.add('filter-by-opened')};
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
  }

  closeDrawer() {
      this.isOpen = false;
      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');
      this.openedBy?.setAttribute('aria-expanded', false);
      setTimeout(() => {
        this.classList.remove('collection-sorting');
      }, 500);
      
      SiteOverlay.prototype.hideOverlay();
      document.body.classList.remove('filter-by-opened');
      Utility.removeTrapFocus(this.openedBy);
      this.openedBy = null;

      if (this.id == 'storefront-filter-drawer') {
        let openedDrawers = this.querySelectorAll('.collapsible_panel.open');
        openedDrawers?.forEach(drawer => {
          drawer.classList.remove('open');
          drawer?.querySelector('[data-toggle="panel"]')?.setAttribute('aria-expanded','false');
          drawer?.querySelector('[data-toggle="panel"]')?.setAttribute('aria-expanded','false');
          drawer?.querySelector('[data-panelcontent]')?.classList.remove('open');
          drawer?.querySelector('[data-panelcontent]')?.classList.remove('open');
        });

      }
  }

  resetOtherDrawers(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
  }
}
customElements.define('custom-drawer', CustomDrawer);

const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index+2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index+1}"]`);

    // Pause previous slide video if available
    if(prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')){
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if(videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if(prevSlide && activeSlide.querySelector('.custom-video-container')){
      let customElement = activeSlide.querySelector('custom-video');
      if(customElement.videoStatus == 'empty'){
        customElement.toggleView();
      }else{
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if(videoEle) customElement._playVideo(videoEle);
      }
    }
  });
});


// Select all hotspot buttons
const hotspotButtons = document.querySelectorAll(".hotspot-tooltip-btn");

hotspotButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
        event.stopPropagation(); // Prevent event from bubbling

        const parentHotspot = this.closest(".hotspot"); // Get the parent hotspot
        const isAlreadyOpen = parentHotspot.classList.contains("open");

        // Close any open hotspots before opening a new one
        document.querySelectorAll(".hotspot.open").forEach((hotspot) => {
            hotspot.classList.remove("open");
        });

        // Toggle 'open' class for the clicked hotspot
        if (!isAlreadyOpen) {
            parentHotspot.classList.add("open");
        }
    });
});

// Close hotspot when clicking on the close icon inside the tooltip
document.querySelectorAll(".hotspot-tooltip svg").forEach((closeBtn) => {
    closeBtn.addEventListener("click", function (event) {
        event.stopPropagation(); // Prevent closing everything
        const parentHotspot = this.closest(".hotspot");
        if (parentHotspot) {
            parentHotspot.classList.remove("open");
        }
    });
});

// Close all tooltips when clicking outside
document.addEventListener("click", function () {
    document.querySelectorAll(".hotspot.open").forEach((hotspot) => {
        hotspot.classList.remove("open");
    });
});


class ReadMoreComponent extends HTMLElement {
  constructor() {
    super();

    // Parse HTML from <script type="application/json"> block
    const jsonScript = this.querySelector('script[type="application/json"]');
    this.fullContent = jsonScript ? JSON.parse(jsonScript.textContent) : '';

    // Get truncate values from attributes
    this.desktopLimit = parseInt(this.getAttribute('data-desktop-truncate'), 10) || 0;
    this.mobileLimit = parseInt(this.getAttribute('data-mobile-truncate'), 10) || 0;

    this.isExpanded = false;

    this.render();
    this.setupEventListeners();
  }

  /**
   * Gets the current character limit based on viewport size.
   * Returns `null` if limit is 0 or invalid (means show full content).
   */
  getCurrentLimit() {
    const width = window.innerWidth;
    const limit = width < 768 ? this.mobileLimit : this.desktopLimit;
    return (isNaN(limit) || limit <= 0) ? null : limit;
  }

  /**
   * Truncates HTML content preserving tag structure.
   * @param {string} content - Full HTML content.
   * @param {number} limit - Character limit.
   * @returns {{ truncated: boolean, html: string }}
   */
  truncateContent(content, limit) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
  
    let charCount = 0;
    let reachedLimit = false;
    let totalVisibleChars = 0;
  
    const countVisibleChars = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        totalVisibleChars += node.textContent.replace(/\s+/g, '').length;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        for (let child of node.childNodes) {
          countVisibleChars(child);
        }
      }
    };
  
    countVisibleChars(tempDiv);
  
    const truncateNode = (node) => {
      if (reachedLimit) return null;
  
      if (node.nodeType === Node.TEXT_NODE) {
        const rawText = node.textContent;
        const strippedText = rawText.replace(/\s+/g, '');
        const countableLength = strippedText.length;
  
        if (charCount + countableLength <= limit) {
          charCount += countableLength;
          return document.createTextNode(rawText); // preserve original formatting
        } else {
          let remaining = limit - charCount;
          let visibleChars = 0;
          let sliced = '';
  
          for (let i = 0; i < rawText.length; i++) {
            const ch = rawText[i];
            if (!/\s/.test(ch)) visibleChars++;
            sliced += ch;
            if (visibleChars >= remaining) break;
          }
  
          charCount = limit;
          reachedLimit = true;
          return document.createTextNode(sliced + '...');
        }
      }
  
      if (node.nodeType === Node.ELEMENT_NODE) {
        const clone = node.cloneNode(false);
        for (let child of node.childNodes) {
          const truncatedChild = truncateNode(child);
          if (truncatedChild) clone.appendChild(truncatedChild);
          if (reachedLimit) break;
        }
        return clone;
      }
  
      return null;
    };
  
    const frag = document.createDocumentFragment();
    for (let child of tempDiv.childNodes) {
      const result = truncateNode(child);
      if (result) frag.appendChild(result);
      if (reachedLimit) break;
    }
  
    const container = document.createElement('div');
    container.appendChild(frag);
  
    return {
      truncated: totalVisibleChars > limit,
      html: container.innerHTML
    };
  }

  /**
   * Renders the initial component structure.
   */
  render() {
    const limit = this.getCurrentLimit();
    const { truncated, html } = limit ? this.truncateContent(this.fullContent, limit) : { truncated: false, html: this.fullContent };

    this.innerHTML = `
      <div class="read-more-container">
        <div class="read-more-content ${truncated ? 'truncated' : 'expanded'}" data-rm-content>
          ${html}
        </div>
        <span class="mt-1 read-more-btn text-dark-red" data-rm-toggle style="${truncated ? '' : 'display: none'}">
          <span class="more">Read more</span>
          <span class="less">Read less</span>
        </span>
      </div>
    `;
  }

  /**
   * Sets up toggle and resize event listeners.
   */
  setupEventListeners() {
    const btn = this.querySelector('[data-rm-toggle]');
    const contentEl = this.querySelector('[data-rm-content]');
  
    if (!btn || !contentEl) return;
  
    const animateHeight = (el, start, end, duration = 300, callback) => {
      el.style.overflow = 'hidden';
      el.style.height = `${start}px`;
  
      requestAnimationFrame(() => {
        el.style.transition = `height ${duration}ms ease`;
        el.style.height = `${end}px`;
  
        const transitionEnd = () => {
          el.style.transition = '';
          el.style.height = '';
          el.style.overflow = '';
          el.removeEventListener('transitionend', transitionEnd);
          if (callback) callback();
        };
  
        el.addEventListener('transitionend', transitionEnd);
      });
    };

    btn.addEventListener('click', () => {
      this.isExpanded = !this.isExpanded;
    
      if (this.isExpanded) {
        const limit = this.getCurrentLimit();
    
        // Get truncated HTML and render it first
        const truncated = limit ? this.truncateContent(this.fullContent, limit) : { html: this.fullContent };
        contentEl.innerHTML = truncated.html;
    
        const startHeight = contentEl.offsetHeight;
    
        // Immediately set full content (so it's visible during animation)
        contentEl.innerHTML = this.fullContent;
    
        // Temporarily force a reflow so the browser knows about the new height
        contentEl.style.height = 'auto';
        const endHeight = contentEl.offsetHeight;
    
        // Animate from truncated to full height
        contentEl.style.height = `${startHeight}px`;
        requestAnimationFrame(() => {
          contentEl.style.transition = 'height 300ms ease';
          contentEl.style.height = `${endHeight}px`;
        });
    
        // Clean up after animation
        const transitionEnd = () => {
          contentEl.style.transition = '';
          contentEl.style.height = '';
          contentEl.classList.remove('truncated');
          contentEl.classList.add('expanded');
          contentEl.removeEventListener('transitionend', transitionEnd);
        };
    
        contentEl.addEventListener('transitionend', transitionEnd);
        btn.classList.add('expanded');
    
      } else {
        const limit = this.getCurrentLimit();
        const { html } = limit ? this.truncateContent(this.fullContent, limit) : { html: this.fullContent };
    
        const startHeight = contentEl.offsetHeight;
    
        // Temporarily render truncated content to measure end height
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.visibility = 'hidden';
        tempDiv.style.pointerEvents = 'none';
        tempDiv.style.width = `${contentEl.offsetWidth}px`;
        tempDiv.innerHTML = html;
        document.body.appendChild(tempDiv);
    
        const endHeight = tempDiv.offsetHeight;
        document.body.removeChild(tempDiv);
    
        // Animate height
        contentEl.style.height = `${startHeight}px`;
        requestAnimationFrame(() => {
          contentEl.style.transition = 'height 300ms ease';
          contentEl.style.height = `${endHeight}px`;
        });
    
        // After animation ends, swap in truncated content
        const transitionEnd = () => {
          contentEl.style.transition = '';
          contentEl.style.height = '';
          contentEl.innerHTML = html;
          contentEl.classList.toggle('truncated', !!limit);
          contentEl.classList.toggle('expanded', !limit);
          contentEl.removeEventListener('transitionend', transitionEnd);
        };
    
        contentEl.addEventListener('transitionend', transitionEnd);
        btn.classList.remove('expanded');
      }
    });
  
    window.addEventListener('resize', () => {
      if (!this.isExpanded) {
        const limit = this.getCurrentLimit();
        const { html, truncated } = limit ? this.truncateContent(this.fullContent, limit) : { html: this.fullContent, truncated: false };
        contentEl.innerHTML = html;
        contentEl.classList.toggle('truncated', !!limit && truncated);
        contentEl.classList.toggle('expanded', !limit);
        btn.style.display = truncated ? 'inline-block' : 'none';
      }
    });
  }
}

customElements.define('read-more-component', ReadMoreComponent);